export default __webpack_public_path__ + "0b915455e4e1194e8fcccc1f889dd5a2.svg";